import { render } from "./App.vue?vue&type=template&id=69a66308"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "primevue/resources/themes/saga-blue/theme.css?vue&type=style&index=0&lang=css"
import "primevue/resources/primevue.min.css?vue&type=style&index=1&lang=css"
import "primeicons/primeicons.css?vue&type=style&index=2&lang=css"
import "./main.css?vue&type=style&index=3&lang=css"
script.render = render

export default script